















































import { Vue, Component, Emit, Prop } from 'vue-property-decorator'
import ServerError from '@/utils/server_error'
// @ts-ignore
import { MazPhoneNumberInput } from 'maz-ui'
import { IdentityAPI } from '@/api/identity'

@Component({
  components: {
    MazPhoneNumberInput
  }
})
export default class PhoneNumberConfirmation extends Vue {
  @Prop({ type: String, default: '' })
  phoneNumber!: string

  isLoading: boolean = false
  isValid: boolean = false
  verificationCode: string = ''
  verificationCodeRules: Function[] = [(v: any) => !!v || 'required']

  @Emit('confirm')
  confirm() {
    return this.verificationCode
  }

  /* Methods */
  async onConfirm() {
    this.isLoading = true
    try {
      if (!this.isValid) {
        this.$toast.error(this.$t('PhoneNumberConfirmation.InvalidCode'))
        return
      } else {
        const confirmationResult = await IdentityAPI.confirmAccountPhoneNumberRequest(
          {
            phoneNumber: this.phoneNumber,
            verificationCode: this.verificationCode
          }
        )
        if (confirmationResult.status === 200) {
          this.$toast.info(this.$t('PhoneNumberConfirmation.Success'))
          this.confirm()
        } else {
          this.$toast.error(this.$t('PhoneNumberConfirmation.Failure'))
        }
      }
    } catch (err) {
      this.$toast.error(this.$t('PhoneNumberConfirmation.Failure'))
      console.error(err)
    } finally {
      this.isLoading = false
    }
  }
}
